








































import { Breakpoint, getBreakpoint } from '@/shared/UI/Breakpoint';
import { Styled }                    from '@/shared/UI/Styled';
import { ProfileState }              from '@/store/profile/types';
import { Component, Vue }            from 'vue-property-decorator';
import { Getter, State }             from 'vuex-class';

const namespace: string = 'profile';

@Component
export default class QrCode extends Vue implements Styled {

  public fab: boolean = false;

  @State('profile')
  private profile: ProfileState;

  @Getter('social', { namespace })
  private social: string;

  get styled() {
    const breakpoint = getBreakpoint(this);
    return { ...classes(breakpoint), breakpoint };
  }
}

const classes = (bp: Breakpoint) => ({
  social: {
    'social': true,
    'social-mobile': bp.smAndDown
  }
});
